module.exports = "<template>\n    ${ value.fromDate | date:\"L\"   } - ${ value.toDate | date:\"L\"  }\n</template>\n";